import React, { useState, useEffect } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { TextField, Checkbox, FormControlLabel } from "@mui/material";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import ApiAgentCommission from "../../../core/api/api.agentCommission";
import SwalMessage from "../_Components/SwalMessage";
import { useNavigate } from "react-router-dom";
import ApiSupplier from "../../../core/api/api.supplier";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiHome from "../../../core/api/api.home";

const agentCommissionTypeList = [
  { value: "1", label: "صندلی رویداد" },
  { value: "0", label: "آیتم تفریح" },
];

export const CreateCommissionGroupModal = ({
  showCreateCommissionGroupModal,
  setShowCreateCommissionGroupModal,
  selectedCommissionId
}) => {
  const navigate = useNavigate();
  let handleClose = (e) => {
    setShowCreateCommissionGroupModal(false);
  };
  const [supplierList, setSupplierList] = useState();
  const [hasDefaultCommission, setHasDefaultCommission] = useState(false);


  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      id: selectedCommissionId,
      name: "",
      isActive: true,
      commissionType: { value: 0, label: "آیتم تفریح" }
    },
  });

  useEffect(() => {
    (async () => {
      try {
        // دریافت لیست همه تامین کننده ها
        const suppliersList = await ApiSupplier.getAllSuppliersName();
        setSupplierList(suppliersList);
        if (selectedCommissionId && selectedCommissionId !== 0) {
          // fetching for the data from the server
          const res = await ApiAgentCommission.getAgentCommissionById({
            id: selectedCommissionId,
          });
          if (res.succeeded) {
            setValue("name", res.data?.name);
            setValue("isActive", res.data?.isActive);
            setHasDefaultCommission(res.data.isDefault === true);
            if (res.data.supplierId) {
              const selectedSupplier = suppliersList.find((supplier) => supplier.id === res.data.supplierId);
              if (selectedSupplier) {
                const selectedOption = {
                  value: selectedSupplier.id,
                  label: selectedSupplier.companyName,
                };
                setValue("supplierId", selectedOption);
              }
            }
          } else {
            SwalMessage({
              title: res.message,
              iSsuccess: res.succeeded,
              timer: 5000,
            });
          }
        }
      } catch (error) {
        console.log("error :>> ", error);
      }
    })();
    return () => { };
  }, []);

  const isForCreateCommissionGroup = selectedCommissionId === 0;
  const handleSupplierChange = async (supplierId) => {
    const response = await ApiAgentCommission.getAllAgentCommissionsBySupplierId({ supplierId });
    if (response.data?.length > 0) {
      setHasDefaultCommission(true);
      setValue("name", "");
    }
    else {
      setHasDefaultCommission(false);
      setValue("name", "پیش فرض");
    }
  }
  const onSubmit = async (data) => {
    try {
      data.supplierId = data.supplierId?.value;
      const ct = data.commissionType.value
      delete data.commissionType
      data.isDefault = hasDefaultCommission ? false : true;
      const response = await ApiAgentCommission.createAgentCommission(data);
      SwalMessage({
        title: response.message,
        iSsuccess: response.succeeded,
        timer: 5000,
      });
      handleClose();
      if (ct == 0 && response.succeeded == true && data.id === 0) {
        const idOfCommissionGroup = response.data;
        navigate(`/editAgentCommissionItems/${idOfCommissionGroup}?ourDefault=true`);
      }
      else if (ct == 1 && response.succeeded == true && data.id === 0) {
        const idOfCommissionGroup = response.data;
        navigate(`/supplierCommissionEvent/${idOfCommissionGroup}?ourDefault=true`);
      }
      SwalMessage({
        title: response.message,
        iSsuccess: response.succeeded,
        timer: 5000,
      });
      if (data.id !== 0) document.getElementById("submitButton").click();
    } catch (error) {
      console.log("error=", error);
    }
  };

  return (
    <div>
      <Modal
        centered
        show={showCreateCommissionGroupModal}
        onHide={handleClose}
      >
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>
              {`${isForCreateCommissionGroup ? "ایجاد" : "ویرایش"} گروه کمیسیون`}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs="12">
                <Controller
                  name="supplierId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <SelectComponent
                      options={supplierList?.map((item) => ({
                        value: item.id,
                        label: item.companyName,
                      }))}
                      placeholder="تامین کننده"
                      className="mt-5"
                      field={field}
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption); // مقدار فیلد در فرم آپدیت می‌شود
                        handleSupplierChange(selectedOption?.value);
                      }}
                    />
                  )}
                />
                {errors.supplierId && (
                  <span className="text-danger text-right">
                    تامین کننده را وارد نمایید{" "}
                  </span>
                )}
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <Controller
                  name="name"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <TextField
                      label="نام گروه کمیسیون  "
                      margin="normal"
                      variant="outlined"
                      error={!!errors.name}
                      size="small"
                      {...field}
                      onInput={field.onChange}
                      disabled={!hasDefaultCommission}
                    //InputLabelProps={{ shrink: true }}
                    />
                  )}
                />
                {errors.name?.type === "required" && (
                  <span className="text-danger text-right">
                    نام گروه کمیسیون را وارد نمایید{" "}
                  </span>
                )}
                {!hasDefaultCommission && (
                  <p>
                    اولین گروه کمیسیون ایجاد شده باید حتما "پیش فرض" ثبت گردد.
                    برای گروه های بعدی میتوانید نام مورد نظر خود را ثبت نمایید
                  </p>
                )}
              </Col>
              <Col xs="12">
                <Controller
                  name="commissionType"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <SelectComponent
                      isDisabled={!!selectedCommissionId}
                      options={agentCommissionTypeList}
                      placeholder="نوع کمیسیون"
                      className="mt-5"
                      field={field}
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption); // مقدار فیلد در فرم آپدیت می‌شود
                      }}
                    />
                  )}
                />
                {errors.commissionType && (
                  <span className="text-danger text-right">
                    نوع کمیسیون را وارد نمایید
                  </span>
                )}
              </Col>
              <Col xs="12">
                <FormControlLabel
                  control={
                    <Controller
                      control={control}
                      name={"isActive"}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                      }) => (
                        <Checkbox
                          color="primary"
                          onBlur={onBlur}
                          onChange={onChange}
                          checked={value || false}
                          inputRef={ref}
                        />
                      )}
                    />
                  }
                  label="فعال"
                />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && (
                <Spinner animation="border" variant="warning" size="sm" />
              )}
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
